// vue
import { ref } from 'vue';

// composables
import { IPNL, usePNL } from './usePNL';

interface IWsOrders {
  id: number,
  amount: string | number,
  amount_comm: string | number,
  amount_usd: string | number,
  amount_usd_comm: string | number,
  amount_processed: string | number,
  rate: string | number,
  status: number,
  type: string,
  cycle: number,
  ts: string,
  ts_end: string,
}

interface CurrentOrder {
  key?: string,
  type?: string,
  price?: number,
  value?: number | string,
  time?: number,
  orderType?: string,
}

interface IOrders {
  [key: string]: CurrentOrder,
}

interface IWsData {
  algo: string;
  cycle?: ICycle;
  pair: string;
  orders?: IWsOrders[];
}

interface IData {
  pair: string;
  orders: IOrders;
}

interface ICycle {
  id: string | number;
  status: number;
  fix_price: string;
  exchange_price: string;
  to_zero_price: string;
}

const toUnixTimestamp = (dateString: string): number => {
    // Заменяем 'T' на пробел и удаляем 'Z', если он есть
    const normalizedDateString = dateString.replace('T', ' ').replace('Z', '');

    // Получаем временную зону пользователя
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Создаем объект Date с учетом локального времени пользователя
    const date = new Date(normalizedDateString);

    // Преобразуем в строку с учетом временной зоны
    const localDateString = date.toLocaleString('en-US', { timeZone });

    // Создаем объект Date для строки с учетом временной зоны
    const localDate = new Date(localDateString);

    // Возвращаем Unix timestamp (в секундах)
    return Math.floor(localDate.getTime() / 1000);
};

export const useTvOrders = () => {
    // chart
    const chartModel = ref<IData>({ pair: '', orders: {} });

    const usePrepareTvOrders = ({
        algo,
        cycle,
        pair,
        orders,
    }: IWsData) => {
        const model: IData = { pair, orders: {} };
  
        model.pair = pair;
  
        const setOrders = (key: string, value: CurrentOrder) => {
            model.orders[key] = value;
        };
  
        if (Array.isArray(orders)) {
            orders.forEach(el => {
                if (el.status == 0) {
                    // подготавливаем активные ордера
      
                    setOrders(String(el.id), {
                        price: Number(el.rate),
                        value: el.amount,
                        orderType: el.type,
                    });
                } else if (el.status == 1) {
                    // подготавливаем выпоненые ордера
      
                    setOrders(`history__${el.id}`, {
                        price: Number(el.rate),
                        time: toUnixTimestamp(el.ts_end),
                        orderType: el.type,
                    });
                }
            });
        }

        if (cycle) {
            // calc pnl
            const {
                zeroDelta,
                course,
            }: IPNL = usePNL({
                algo,
                price: `${cycle.exchange_price}\n${cycle.fix_price}\n${cycle.to_zero_price}`,
            });

            const pnl = (parseFloat(((zeroDelta / course) * 100).toFixed(2))) * -1;
            if (!isNaN(pnl)) {
            // подготавливаем выпоненые ордера
  
                setOrders('pnl', {
                    price: Number(cycle.to_zero_price),
                    value: pnl,
                });
            }
        }

        chartModel.value = model;
    };

    const clearTvOrders = () => {
        Object.keys(chartModel.value.orders).forEach((el: string) => {
            if (!el.includes('history__')) {
                delete chartModel.value.orders[el];
            }
        });
    };

    const clearAllTvOrders = () => {
        Object.keys(chartModel.value.orders).forEach((el: string) => {
            delete chartModel.value.orders[el];
        });
    };
  
    return {
        chartModel,
        clearTvOrders,
        usePrepareTvOrders,
        clearAllTvOrders,
    };
};

